/*
|--------------------------------------------------------------------------
| Views: Slider Basic
|--------------------------------------------------------------------------
*/

/**
 * Slider Basic View
 * @namespace
 */
__gh__webApp.views.sliderBasic = {

	"callbacks": function(bucket){
		__gh__webApp.utilities.slider.loadAllSliders();
	},


	"getSubView": function(bucket){
		var slidesToShow	= (bucket.hasAd) ? 4 : 2,
			sliderSettings	= this.getSliderSettings(bucket.id,slidesToShow);

		//Update bucket
		bucket.view.name 					= "buckets/sliderBasic/default";
		bucket.view.sliderSettings 			= sliderSettings;
		return bucket;
	},


	"getSliderSettings":function(bucketID,slidesToShow){
		var sliderSettings = {
			"infinite":true,
			"speed":300,
			"slidesToShow":slidesToShow,
			"slidesToScroll":slidesToShow,
			"lazyLoad":"ondemand",
			"arrows":true,
			"dots":false
		};
		switch(slidesToShow){
			case 2:
				sliderSettings.responsive = [
					{
						"breakpoint":1024,
						"settings":{"slidesToShow":2,"slidesToScroll":2}
					},
					{
						"breakpoint":480,
						"settings":{"slidesToShow":1,"slidesToScroll":1/*,"appendArrows":"#gh-slider-nav-bottom-"+bucketID*/}
					}
				];
				break;
			case 4:
				sliderSettings.responsive = [{
					"breakpoint": 1200,
					"settings"	: {"slidesToShow": 4,"slidesToScroll": 4}
				}, {
					"breakpoint": 992,
					"settings"	: {"slidesToShow": 3,"slidesToScroll": 3
					}
				}, {
					"breakpoint": 480,
					"settings": {"slidesToShow": 2,"slidesToScroll": 2}
				}];
				break;
		}

		return sliderSettings;
	}

};
